import React from "react";
import StudentEquipmentAssignmentsTable from "./components/StudentEquipmentAssignmentsTable";

export default function StudentEquipmentAssignments() {
  return (
    <div className="grid h-full min-h-0 grid-cols-1 gap-5">
      <StudentEquipmentAssignmentsTable />
    </div>
  );
}


